import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { setLanguage } from "@/lib/i18n";
import { publicPage, updateSeo } from "@/lib/seo";

export default function PageMetadata() {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    const page = publicPage(pathname);
    if (page) setLanguage(page.language);
    updateSeo(pathname);
  }, [pathname]);
  return null;
}
